export default "__VITE_ASSET__DHKfAwI0__"